import MobileWarningDialog from 'components/DesignSystems/MobileWarning/MobileWarningDialog';
import CollapsibleStrategiesList from 'components/IAP/CollapsibleStrategiesList';
import CollapsibleTacticsList from 'components/IAP/CollapsibleTacticsList';
import CollapsibleResourceSetsList from 'components/IAP/CollapsibleResourceSetsList';
import CollapsibleCustomResourceSiteTypesList from 'components/IAP/CollapsibleCustomResourceSiteTypesList';
import CollapsibleStrikeTeamsList from 'components/IAP/CollapsibleStrikeTeamsList';
import CollapsibleCustomResourceTypeList from 'components/IAP/CollapsibleCustomResourceTypeList';
import CollapsibleCustomResourceKindList from 'components/IAP/CollapsibleCustomResourceKindList';
import CollapsibleResourceSitesList from 'components/IAP/CollapsibleResourceSitesList';
import { ORGANIZATION } from 'components/IAP/ICSConstants';

export default function IcsLibrary() {
  return (
    <MobileWarningDialog>
      <div className="d-flex">
        <div className="maincontent flex-grow-1">
          <div className="d-flex flex-column overflow-auto py-6 px-6 gap-6">
            <div>
              <h1>ICS Organization Resource Library</h1>
            </div>
            <div className="d-flex flex-column gap-3">
              <div className={'iap-section-title'}>Command</div>
              <div className={'iap-section-grouping'}>
                <CollapsibleStrategiesList scope={ORGANIZATION} />
                <CollapsibleTacticsList scope={ORGANIZATION} />
              </div>

              <div className={'iap-section-title'}>Operations</div>
              <div className={'iap-section-grouping'}>
                <CollapsibleResourceSetsList />
                <CollapsibleStrikeTeamsList />
                <CollapsibleResourceSitesList />
                <CollapsibleCustomResourceKindList />
                <CollapsibleCustomResourceTypeList />
                <CollapsibleCustomResourceSiteTypesList />
              </div>
            </div>
          </div>
        </div>
      </div>
    </MobileWarningDialog>
  );
}
